import { Flex, Padding } from 'components/base/layout-components';
import React from 'react';
import Text from 'components/base/Text';
import { SingleSelectedMenu } from './SingleSelectedMenu';

export const SelectStateFieldSection = ({
  title,
  itemsList,
  buttonTitle,
  selectedItem,
  setSelectedItem
}) => {
  return (
    <Flex direction='row' items='center'>
      <Text size='medium'>{title}</Text>
      <Padding l='medium'>
        <SingleSelectedMenu
          itemsList={itemsList}
          buttonTitle={buttonTitle}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
      </Padding>
    </Flex>
  );
};
